// Helper for tracking events in Product Fruits
import { productFruits } from 'product-fruits'

export function useProductFruits() {
  const { productFruitsEnabled } = useRuntimeConfig().public
  const workspaceCode = useCountryConfig().productFruitsCode

  const isEnabled = () => Boolean(productFruitsEnabled && workspaceCode)

  function track(eventName: string) {
    if (!isEnabled())
      return

    productFruits.safeExec(() => {
      window.productFruits?.api?.events?.track(eventName)
    })
  }

  function setFirstOrderCompleted(completed: boolean) {
    if (!isEnabled())
      return

    const email = useUserStore().data?.email
    if (!email)
      return

    productFruits.safeExec(() => {
      window.productFruits?.identifyUser?.({
        username: email,
        props: { firstOrderCompleted: completed },
      })
    })
  }

  /** Tear down PF UI/session (e.g. on logout) so banners/checklists do not linger. */
  function destroy() {
    if (!isEnabled())
      return

    window.productFruits?.services?.destroy?.()
  }

  return {
    isEnabled,
    track,
    setFirstOrderCompleted,
    destroy,
  }
}
